import { render, staticRenderFns } from "./RequisicaoAnalise.vue?vue&type=template&id=1bc0c1ab"
import script from "./RequisicaoAnalise.vue?vue&type=script&lang=js"
export * from "./RequisicaoAnalise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports